import React, { useState, createContext } from 'react';
import { PageProps } from 'gatsby';

type metadatatype = {
    slug: string | undefined;
    blogTitle: string | undefined;
    blogShortDescription: string | undefined;
    displayPageName: string | undefined;
    preferredLanguage: string | undefined;
    location: string | PageProps['location'] | undefined;
    pagePaths: { [key: string]: string };
};

type Props = {
    metadata: metadatatype;
};

export const PageMetadataContext = createContext<metadatatype>({
    slug: undefined,
    blogTitle: undefined,
    blogShortDescription: undefined,
    displayPageName: undefined,
    preferredLanguage: undefined,
    location: undefined,
    pagePaths: {},
});

const PageMetadataProvider: React.FC<Props> = ({ metadata, ...props }) => {
    const [pageMetaData, setPageMetaData] = useState<metadatatype>(metadata);

    return (
        <PageMetadataContext.Provider value={pageMetaData}>
            {props?.children}
        </PageMetadataContext.Provider>
    );
};

export default PageMetadataProvider;
